import React, { useContext, useEffect } from 'react'
import { AuthContext } from '../store/ContextStore'
import { useChatHistory } from '../store/ChatHistoryContext'
import { useNavigate } from "react-router-dom";
import { ADMIN_DASHBOARD, PROFILE_PAGE } from '../constants/routes';

type UserDetails = {
    username: string;
    isadmin?: boolean;
};

interface UserInfoDropdownProps {
  isOpen?: boolean;
  setIsOpen?: (open: boolean) => void;
}

function UserInfoDropdown({ isOpen = false, setIsOpen }: UserInfoDropdownProps) {
    const navigate = useNavigate();
    const {setUser, setIsAuthenticated} = useContext(AuthContext)
    const { clearHistory } = useChatHistory()
    const [userDetails, setUserDetails] = React.useState<UserDetails | null>({
        username: "",
        isadmin: false
    });

    function handleLogout(e:any){
        e.preventDefault()
        clearHistory();
        localStorage.clear();
        navigate("/login")
        setUser({});
        setIsAuthenticated(false);
    }

    useEffect(() => {
        const data = localStorage.getItem("sid_user");
        if (data) {
            const parsedData = JSON.parse(data);
            console.log("parsedData",parsedData);
            setUserDetails((prev) => ({
                ...prev,
                username: parsedData.username || "",
                isadmin: parsedData.isadmin || false
            }));
        }
    }, []);


    return (
        <>
            {/* <button
                id="dropdownInformationButton"
                onClick={(e) => e.stopPropagation()}
                className="relative flex items-center"
                type="button"
                aria-expanded={isOpen}
                aria-haspopup="true"
            >

                <svg
                    className={`w-4 h-4 ml-1 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                    aria-hidden="true"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="2"
                        d="M19 9l-7 7-7-7"
                    />
                </svg>
            </button> */}

            {/* <!-- Dropdown menu --> */}
            {
                isOpen
                    ?
                    <div
                        id="dropdownInformation"
                        className="absolute right-0 top-full z-50 mt-0 w-44 rounded-lg border border-[#DEE7F4] bg-white"
                    >
                        {/* Triangle (Pointer) */}
                        <div className="absolute -top-[8px] right-[6px] inline-block h-2 w-4 overflow-hidden">
                            <div className="h-2 w-2 bg-white border border-[#DEE7F4] rotate-45 transform origin-bottom-left"></div>
                        </div>
                        <ul className="py-2 text-sm text-[#292929] font-primary font-medium border-b border-[#DEE7F4]" aria-labelledby="dropdownInformationButton">
                            <li>
                                <a href="/dashboard" className="block px-4 py-2 hover:bg-gray-100 text-center" onClick={() => setIsOpen?.(false)}>
                                    Dashboard
                                </a>
                            </li>
                            <li>
                                {!userDetails?.isadmin && (
                                <a href={PROFILE_PAGE} className="block px-4 py-2 hover:bg-gray-100 text-center" onClick={() => setIsOpen?.(false)}>
                                    Profile                            
                                </a>
                                )}
                            </li>
                            {userDetails?.isadmin && (
                                <>
                                    <li>
                                        <a href={ADMIN_DASHBOARD} className="block px-4 py-2 hover:bg-gray-100 text-center" onClick={() => setIsOpen?.(false)}>
                                            Admin Dashboard
                                        </a>
                                    </li>
                                </>
                            )}
                        </ul>
                        <div className="py-2">
                            <a
                                href="/login"
                                className="block px-4 py-2 text-sm font-medium font-primary text-[#C22222] hover:bg-gray-100 text-center"
                                onClick={(e) => {
                                    setIsOpen?.(false);
                                    handleLogout(e);
                                }}
                            >
                                Sign out
                            </a>
                        </div>
                    </div>

                    :
                    ""
            }
        </>
    )
}

export default UserInfoDropdown
